<template>
  <div class="login-page">
    <div class="contain-box">
      <div class="header-logo-ban" @click="goHome">
        <div>聊城市房地产中介机构监管服务平台</div>
        <div style="font-size: 16px">
          LIAOCHENG REAL ESTATE INTERMEDIARY SUPERVISION SERVICE PLATFORM
        </div>
      </div>
      <div class="sign-in-box">
        <div class="sign-title">用户登录</div>
        <template v-if="logType === 'pass'">
          <input
            @focus="errorStr = ''"
            placeholder="请输用户名"
            v-model.trim="phone"
            class="log-ipt"
            type="text"
            maxlength="16"
          />
        </template>
        <template v-else>
          <input
            placeholder="请输入手机号"
            @focus="errorStr = ''"
            v-model="codePhone"
            class="log-ipt"
            type="text"
          />
          <div class="phone-number-box">
            <input
              v-model="verification"
              @focus="errorStr = ''"
              class="register-verification"
              type="text"
              placeholder="请输入手机验证码"
            />
            <div v-if="!codeTime" @click="getCode" class="verification-btn">
              {{ verBtnStr }}
            </div>
            <div v-else class="verification-btn">
              {{ remainingTime }}秒后重试
            </div>
          </div>
        </template>

        <div @click="logClick" class="submit-btn">登录</div>

        <div class="btn-clr-box">
          <span @click="logType = 'phone'" v-if="logType === 'pass'"
            >验证码登录</span
          ><span @click="logType = 'pass'" v-else>密码登录</span>
          /
          <span @click="goRegister">注册</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LogIn",
  data() {
    return {
      logType: "pass",
      phone: "",
      password: "",
      codePhone: "",
      verification: "",
      codeTime: false,
      remainingTime: 60,
      errorStr: "",
      verBtnStr: "获取验证码",
      jumpTime: 3,
    };
  },
  mounted() {},
  methods: {
    goRegister() {
        this.$router.push({
               path: "/personalRegister", //跳转的路径
        });
    },
    testData() {
      if (this.logType === "pass") {
        if (!/^1[3456789]\d{9}$/.test(this.phone)) {
          // this.errorStr = "手机号格式不正确，请重新输入";
          this.showToastBtm("手机号格式不正确，请重新输入");

          return false;
        }
        if (
          !this.password ||
          this.password.length < 6 ||
          this.password.length > 16
        ) {
          // this.errorStr = "密码请输6-16个字符";
          this.showToastBtm("密码请输6-16个字符");

          return false;
        }
        return true;
      } else {
        if (!/^1[3456789]\d{9}$/.test(this.codePhone)) {
          // this.errorStr = "手机号格式不正确，请重新输入";
          this.showToastBtm("手机号格式不正确，请重新输入");

          return false;
        }
        if (!this.verification || this.verification.length !== 4) {
          // this.errorStr = "验证码格式错误";
          this.showToastBtm("验证码格式错误");
          return false;
        }
        return true;
      }
    },
    /**
     * 点击登录
     */
    logClick() {
      this.logType === "pass" ? this.postPassLog() : this.postPhoneLog();
    },
    /**
     * 用户密码登录
     */
    postPassLog() {
      if (!this.phone) {
        this.showToastBtm("请输入用户名");
      }
      this.$router.replace({
          //核心语句
          path: "/", //跳转的路径
      });
      return
      this.$setUserInfo({
        userName: this.phone,
      });
      const canReturn = sessionStorage.getItem("canReturn");
      if (canReturn) {
        location.replace(canReturn);
      } else {
        this.$router.replace({
          //核心语句
          path: "/", //跳转的路径
        });
      }
      window.sessionStorage.removeItem("canReturn");
    },
    goHome() {
        this.$router.replace({
          //核心语句
          path: "/", //跳转的路径
        });
    },
    /**
     * 手机登录
     */
    postPhoneLog() {
      this.showToastBtm("请使用用户名登录");
    },
    /**
     * 获取验证码
     */
    getCode() {
      if (!/^1[3456789]\d{9}$/.test(this.codePhone)) {
        this.showToastBtm("手机号格式不正确，请重新输入");
        return;
      }
      this.showToastBtm("请使用用户名登录");
      //   this.verBtnStr = "发送中...";
      //   this.$http
      //     .post("sms", {
      //       phone: this.codePhone.trim(),
      //     })
      //     .then(
      //       (res) => {
      //         if (res.data.code === 200) {
      //           this.verBtnStr = "获取验证码";
      //           this.playCodeTime();
      //         } else {
      //           this.showToastBtm(res.data.msg || "系统错误");
      //           this.verBtnStr = "获取验证码";
      //         }
      //       },
      //       (e) => {
      //         this.showToastBtm("网络错误");
      //         this.verBtnStr = "获取验证码";
      //       }
      //     );
    },
    /**
     * code倒计时
     */
    playCodeTime() {
      this.codeTime = true;
      this.remainingTime = 60;
      let getCodeTime = setInterval(() => {
        if (this.remainingTime <= 1) {
          clearInterval(getCodeTime);
          this.codeTime = false;
        }
        this.remainingTime--;
      }, 1000);
    },
  },
};
</script>

<style lang="less">
.login-page {
  height: 100%;

  .contain-box {
    width: 100%;
    height: 100%;
    background-image: url("../../assets/img/login.jpg");
    background-repeat: no-repeat; //不重复
    background-size: 100% 100%;
    position: fixed;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .header-logo-ban {
      height: auto;
      width: 680px;
      font-size: 34px;
      color: #c3241c;
      font-weight: bold;
      text-shadow: 0 0 0.3em #fff, 0 0 0.3em #fff, 0 0 0.3em #fff;
      text-align: center;
      margin-top: -200px;
      cursor: pointer;
    }

    .sign-in-box {
      margin-top: 42px;
      width: 400px;
      padding: 0 30px;
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 8px;

      .sign-title {
        height: 29px;
        line-height: 1;
        color: #000;
        font-size: 18px;
        padding: 40px 0 18px;
        text-align: left;
        box-sizing: content-box;
        position: relative;

        .error-box {
          position: absolute;
          left: 0;
          bottom: 6px;
          color: #ff5600;
          font-size: 12px;
        }
      }

      .log-ipt {
        display: block;
        width: 340px;
        height: 42px;
        margin: 0 auto 20px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 8px;
        font-size: 14px;
        color: #000000;
        padding: 15px 20px;
        box-sizing: border-box;
      }

      .phone-number-box {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        .register-verification {
          display: block;
          width: 240px;
          height: 42px;
          border: 1px solid rgba(204, 204, 204, 1);
          border-radius: 8px;
          font-size: 14px;
          color: #000000;
          padding: 15px 20px;
          box-sizing: border-box;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border-right: none;
        }

        .verification-btn {
          width: 100px;
          height: 42px;
          background: #999999;
          border-radius: 8px;
          color: #ffffff;
          font-size: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          border-left: none;
        }
      }

      .btn-clr-box {
        text-align: center;
        margin-top: 22px;
        font-size: 16px;
        color: #999999;
        cursor: pointer;
        padding-bottom: 42px;
      }

      .fn-log-box {
        margin-top: 12px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #323232;
        font-size: 12px;

        div {
          cursor: pointer;
        }

        .log-message {
          display: flex;
          align-items: center;

          img {
            width: 12px;
            height: auto;
            margin-right: 8px;
            cursor: pointer;
          }
        }
      }

      .submit-btn {
        width: 340px;
        height: 40px;
        background: #b1191a;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 20px;
        margin-top: 10px;
        cursor: pointer;
        letter-spacing: 8px;
      }

      .line-box {
        margin-top: 20px;
        height: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #999999;
        font-size: 12px;

        .line {
          width: 120px;
          height: 1px;
          background: rgba(230, 230, 230, 1);
        }
      }

      .log-bottom-box {
        height: 20px;
        margin-top: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .out-log-fn {
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
            margin-right: 8px;
            cursor: pointer;
          }

          span {
            color: #323232;
            font-size: 12px;
            cursor: pointer;
          }

          .s-line {
            height: 18px;
            width: 1px;
            margin: 0 9px;
            background: #323232;
          }
        }

        .register-go {
          display: flex;
          align-items: center;
          color: #e10101;
          font-size: 16px;
          cursor: pointer;
          margin-top: 20px;

          img {
            width: 18px;
            height: 18px;
            margin-right: 4px;
          }
        }
      }
    }
  }
}
</style>
